import {CommentIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {ReviewHeaderTitle} from './shared/ReviewHeaderTitle'
import {ReviewHeaderDescription} from './shared/ReviewHeaderDescription'

export function CommentReview() {
  const {data: reviewers} = useReviewers()

  const commentReviews = reviewers.completedReviews?.filter(review => review.state === 'commented') ?? []

  if (commentReviews.length === 0) {
    return null
  }

  return (
    <ForYouItem
      icon={CommentIcon}
      title={<ReviewHeaderTitle reviews={commentReviews} state="commented" />}
      ariaLabel={`${commentReviews.length} ${commentReviews.length === 1 ? 'comment review' : 'comment reviews'}`}
      itemName="comment-review"
      variant="default"
      description={<ReviewHeaderDescription reviews={commentReviews} />}
    >
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {commentReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
